import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "../constants/clientTime";
import { httpClient } from "@coworker/http-client";

type Note = {
  creator_id: string;
  id: string;
  task_id: string;
  text: string;
};

const fetchTaskNotes = async (taskId: string) => {
  return await httpClient.tasks.get<Note[]>(`/v1/task/${taskId}/notes`);
};

export function useTaskNotes(taskId: string) {
  return useQuery({
    queryKey: ["task", "notes", taskId],
    queryFn: async () => fetchTaskNotes(taskId),
    refetchOnWindowFocus: false,
    staleTime: INTERVAL.HOUR,
    enabled: !!taskId,
  });
}
